export default {"src":"/_next/static/media/pair-3.818e16e6.svg","height":521,"width":545,"blurWidth":0,"blurHeight":0};